import type {LngLat} from '@yandex-delivery/blocks'

export function isDefaultCoordinates(coordinates: LngLat) {
  return coordinates[0] === 0 && coordinates[1] === 0
}
